var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGoogleColored(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.589,
    height: 19.989,
    viewBox: "0 0 19.589 19.989",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M140.145,108.8a8.565,8.565,0,0,0-.211-2.043H130.55v3.709h5.508a4.884,4.884,0,0,1-2.043,3.243l-.019.124,2.967,2.3.206.021a9.772,9.772,0,0,0,2.976-7.351",
    transform: "translate(-120.556 -98.588)",
    fill: "#4285f4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.853,164.388a9.526,9.526,0,0,0,6.618-2.421l-3.154-2.443a5.915,5.915,0,0,1-3.465,1,6.017,6.017,0,0,1-5.686-4.153l-.117.01-3.085,2.388-.04.112a9.987,9.987,0,0,0,8.928,5.508",
    transform: "translate(-12.859 -144.399)",
    fill: "#34a853"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.309,77.824a6.153,6.153,0,0,1-.333-1.977A6.466,6.466,0,0,1,4.3,73.87l-.006-.132L1.168,71.312l-.1.049a9.973,9.973,0,0,0,0,8.973l3.243-2.51",
    transform: "translate(0 -65.853)",
    fill: "#fbbc05"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.853,3.864a5.539,5.539,0,0,1,3.864,1.488L29.538,2.6A9.6,9.6,0,0,0,22.853,0a9.987,9.987,0,0,0-8.928,5.508l3.231,2.51a6.041,6.041,0,0,1,5.7-4.153",
    transform: "translate(-12.859 0)",
    fill: "#eb4335"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleColored);
export default __webpack_public_path__ + "static/media/google-colored.6759849474cf10b0b32dd33445c72970.svg";
export { ForwardRef as ReactComponent };